module.exports = __webpack_public_path__ + "img/more.86a4b3b.svg";